import { useEffect, useRef, useState } from "react";
import EagerSVGIcon from "../../components/EagerSVG";
import { PricingTableProduct } from "../../services/SubscriptionService";
import { useModal } from "@surveying-hub-bv/fe-component-library";
import { CheckoutService } from "../../services/CheckoutService";
import { ExtendedAuthContextInterface } from "../../AuthProvider";
import { ProductsPricingTableDialog } from "../../components/PricingDialogs";


export const NotificationBanner = ({ loggedIn, selected }: {

    loggedIn?: ExtendedAuthContextInterface, selected: {
        name: string,
        data: PricingTableProduct[]
    }

}) => {
    const { showModal } = useModal()
    const storageKey = "notification-banner-gnss-promtion-closed"

    const [isVisible, setIsVisible] = useState(false)
    const bannerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const isClosed = localStorage.getItem(storageKey) === "true"
        setIsVisible(!isClosed);
    }, [storageKey])

    useEffect(() => {
        const updateHeightVar = () => {
            const height = isVisible && bannerRef.current ? bannerRef.current.offsetHeight : 0
            document.documentElement.style.setProperty("--notif-height", `${height}px`)
        }

        updateHeightVar();
        window.addEventListener("resize", updateHeightVar)

        return () => {
            window.removeEventListener("resize", updateHeightVar)
            document.documentElement.style.setProperty("--notif-height", "0px")
        };
    }, [isVisible]);

    const handleClose = () => {
        localStorage.setItem(storageKey, "true")
        setIsVisible(false)
    };

    if (!isVisible) return null

    return <div
        ref={bannerRef}
        className="fixed top-0 inset-x-0 z-40
        border-b dark:border-darkMode-layer1border
        bg-white
        dark:bg-darkMode-layer1color " >
        <div className="mx-auto grid min-h-[56px] grid-cols-[1fr_minmax(0,900px)_1fr] xl:grid-cols-[1fr_minmax(0,1100px)_1fr] items-center px-4 py-3 md:px-8">
            <div className="col-start-2 flex items-center justify-around gap-3">
                <div className="flex gap-2 items-center">
                    <div className="shrink-0 text-black dark:text-darkMode-primary">
                        <EagerSVGIcon name="RtkSignalIcon" width={36} height={36} />
                    </div>

                    <div className="min-w-0 text-sm md:text-lg">
                        <p className="font-semibold text-black dark:text-white">
                            Limited time promotion
                        </p>
                        <p className="text-black/80 dark:text-white/80">
                            50% off <span className="text-primaryGreen">Truepoint</span>
                        </p>
                    </div>
                </div>

                <div className="flex shrink-0 items-center gap-2">
                    {!loggedIn && (
                        <span className="text-sm md:text-lg text-black/80 dark:text-white/80">
                            Log in to see prices
                        </span>
                    )}

                    {loggedIn && (
                        <button
                            className="rounded-[12px] border px-3 py-1.5 
                            text-sm md:text-base
                            font-medium transition-all duration-200 dark:border-darkMode-primary dark:text-darkMode-primary hover:dark:bg-darkMode-primary hover:dark:text-black"
                            onClick={async () => {
                                const createCheckoutSession = async (priceId: string) =>
                                    CheckoutService.createSubscriptionCheckoutSession(
                                        await loggedIn.getToken(),
                                        priceId
                                    )

                                showModal(
                                    <ProductsPricingTableDialog
                                        name={selected.name}
                                        products={selected.data}
                                        createCheckoutSession={createCheckoutSession}
                                    />
                                )
                            }}
                        >
                            See prices
                        </button>
                    )}
                </div>
            </div>

            <div className="flex justify-end">
                <button
                    onClick={handleClose}
                    aria-label="Close notification"
                    className="flex h-8 w-8 items-center justify-center rounded-[10px] text-black transition-colors hover:bg-black/5 dark:text-white dark:hover:bg-white/10"
                >
                    <EagerSVGIcon name="CloseIcon" width={20} height={20} />
                </button>
            </div>
        </div>
    </div>
}